import { render } from "./AyudaMedicoForm.vue?vue&type=template&id=f1d1e8ea&scoped=true"
import script from "./AyudaMedicoForm.vue?vue&type=script&lang=js"
export * from "./AyudaMedicoForm.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=f1d1e8ea&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d1e8ea"]])

export default __exports__